import { FlightRequestFormLeg, FormFlightRequest } from './flightRequestFormMapper';
import { MAXIMUM_MULTILEG_LEGS, MINIMUM_MULTILEG_LEGS } from './flightRequestConstants';
import { defaultLeg } from './defaultLeg';
import isEqual from 'lodash.isequal';
import { TripType } from './tripType';

export function updateFlightRequestWithTripType(flightRequest: FormFlightRequest, tripType: TripType): FormFlightRequest {
    flightRequest.tripType = tripType;
    switch (tripType) {
        case TripType.OneWay:
            flightRequest.legs = getLegsOrDefaultLegsWithinLimits(flightRequest.legs, 1, 1);
            break;
        case TripType.Return:
            flightRequest.legs = getLegsForReturnTrip(flightRequest.legs);
            break;
        case TripType.MultiLeg:
            flightRequest.legs = getLegsOrDefaultLegsWithinLimits(flightRequest.legs, MINIMUM_MULTILEG_LEGS, MAXIMUM_MULTILEG_LEGS);
            break;
    }
    return flightRequest;
}

export function tripTypeFromLegs(legs: FlightRequestFormLeg[]): TripType {
    if (legs.length <= 1) {
        return TripType.OneWay;
    }

    if (legs.length > 2) {
        return TripType.MultiLeg;
    }

    return isEqual(legs[0].departureAirport, legs[1].arrivalAirport)
        && isEqual(legs[0].arrivalAirport, legs[1].departureAirport)
        && legs[0].departureLocation === legs[1].arrivalLocation
        && legs[0].arrivalLocation === legs[1].departureLocation
            ? TripType.Return
            : TripType.MultiLeg;
}

function getLegsOrDefaultLegsWithinLimits(
    legs: FlightRequestFormLeg[],
    minNumberOfLegs: number,
    maxNumberOfLegs: number
): FlightRequestFormLeg[] {
    const numberOfLegs = legs.length;
    if (numberOfLegs > maxNumberOfLegs) {
        return legs.slice(0, maxNumberOfLegs);
    }

    while (legs.length < minNumberOfLegs) {
        addDefaultLeg(legs);
    }
    return legs;
}

function addDefaultLeg(legs: FlightRequestFormLeg[]): void {
    const latestLeg = legs[legs.length - 1];
    const legToAdd = defaultLeg();
    legToAdd.departureAirport = latestLeg.arrivalAirport;
    legToAdd.departureLocation = latestLeg.arrivalLocation;
    legToAdd.date = latestLeg.date;
    legs.push(legToAdd);
}

function setReturnLegAirportsFromOutboundLeg(returnLeg: FlightRequestFormLeg, outboundLeg: FlightRequestFormLeg): void {
    returnLeg.departureAirport = outboundLeg.arrivalAirport;
    returnLeg.departureLocation = outboundLeg.arrivalLocation;
    returnLeg.arrivalAirport = outboundLeg.departureAirport;
    returnLeg.arrivalLocation = outboundLeg.departureLocation;
}

function getLegsForReturnTrip(legs: FlightRequestFormLeg[]): FlightRequestFormLeg[] {
    const numberOfLegs = legs.length;
    if (numberOfLegs >= 2) {
        legs = legs.slice(0, 2);
        setReturnLegAirportsFromOutboundLeg(legs[1], legs[0]);
        return legs;
    }

    if (numberOfLegs === 1) {
        const legToAdd = defaultLeg();
        legToAdd.date = legs[0].date;
        legToAdd.passengers = legs[0].passengers;
        setReturnLegAirportsFromOutboundLeg(legToAdd, legs[0]);
        legs.push(legToAdd);
    }

    return legs;
}
